import { colors } from '@ajaibid/components';
import { formatCurrency, formatDate, formatMoney } from '@ajaibid/utils';

const { NEUTRAL_6, GREEN_5, RED_5 } = colors;

export const headerContents = [
  {
    text: 'Waktu',
    width: '25%',
    align: 'left',
    className: '',
  },
  {
    text: 'Aksi',
    width: '13%',
    align: 'left',
    className: '',
  },
  {
    text: 'Harga',
    width: '40%',
    align: 'right',
    className: '',
  },
  {
    text: 'Vol',
    width: '22%',
    align: 'right',
    className: '',
  },
];

const getActionsText = (text) => {
  switch (text) {
    case 'BUY':
      return { label: 'Beli', color: GREEN_5 };
    case 'SELL':
      return { label: 'Jual', color: RED_5 };
    default:
      return { label: '-', color: NEUTRAL_6 };
  }
};

export const getRunningTradeContents = (data) =>
  data?.map((res = {}) => ({
    raw_data: res,
    result: [
      {
        text: formatDate(res?.tradedAt, 'HH:mm:ss'),
        align: 'left',
        typographyType: 'body',
        bold: false,
        className: '',
        color: NEUTRAL_6,
      },
      {
        text: getActionsText(res?.type).label,
        align: 'left',
        typographyType: 'body',
        bold: false,
        color: getActionsText(res?.type).color,
        className: '',
      },
      {
        text: formatCurrency(res?.price, 'IDR', { withPlusMinusPrefix: false }),
        align: 'right',
        typographyType: 'body',
        bold: false,
        color: NEUTRAL_6,
        className: '',
      },
      {
        text: formatMoney(res?.lot, 0),
        align: 'right',
        typographyType: 'body',
        bold: false,
        color: NEUTRAL_6,
        className: '',
      },
    ],
  }));
